import { Compass, Clock } from "lucide-react";

export default function MiniTourCard({ tour }) {
    const { city, transit_minutes_from_airport, places = [] } = tour;
    return (
        <div
            className="rounded-xl border border-dashed border-[#E5E5E5] bg-[#F5F5F5] p-4"
            data-testid="mini-tour-card"
        >
            <div className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white">
                    <Compass size={13} strokeWidth={2} className="text-[#0A0A0A]" />
                </span>
                <h3 className="text-[14px] font-semibold tracking-tight text-[#0A0A0A]">
                    Mini-Tour: Places to see in {city}
                </h3>
            </div>
            <p className="mt-1 ml-8 text-[12px] text-[#737373]">
                ~{transit_minutes_from_airport} min from airport
            </p>
            <ul className="mt-3 ml-8 space-y-1.5">
                {places.map((p, i) => (
                    <li
                        key={i}
                        className="flex items-center justify-between text-[13px] text-[#0A0A0A]"
                        data-testid={`tour-place-${i}`}
                    >
                        <span>{p.name}</span>
                        <span className="flex items-center gap-1 text-[12px] text-[#737373]">
                            <Clock size={11} strokeWidth={2} />
                            {p.transit_minutes} min
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
